/**
 * Validates an input as a time.
 *
 */
import Validator from 'utils/validators/Validator';

var Errors = {
    Incorrect: 'error.time.incorrect'
};

var DurationValidator = Validator.extend({
    initialize: function(args) {
        this.initializeValidator(args);
        this.required = args.required;
    },

    validateInput: function(value) {
        if (this.required && (!value || value.length < 1)) {
            return Errors.Incorrect;
        }

        if (!this.isValidDuration(value)) {
            return Errors.Incorrect;
        }

        return '';
    },

    isValidDuration: function(time) {
        // regex is duplicated in PRUtils
        // match duration in this form: hh:mm:ss.d or hh:mm:ss or mm:ss
        // maxes out at 40:00:00
        return time
            .toString()
            .match(
                /^(?:(40:00:00)|(?:(?:(?:(?:(?:([1-3]?[0-9])[:]([0-5][0-9]))|([0-5]?[0-9]))[:]([0-5][0-9]))|([0-9]))([.]([0-9]))?))$/
            );
    }
});

export default DurationValidator;
